import Notes from './Notes.view';

export default Notes;
